var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ds-upload"},[_c('a-upload',_vm._g(_vm._b({},'a-upload',_vm.$props,false),_vm.$listeners),[_vm._t("default")],2),_c('span',[_vm._v(_vm._s(_vm.promptTitle))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }